
<template>

  <nav>
    <ul class="main-menu" v-if="!noLogin && user.authenticated">
      <li v-for="(item, index) in role_map[user.user_role]" :key="index"
          v-bind:class="{ 'current-page': $route.path.indexOf(item.path) >= 0 }">
        <router-link :to="{name: item.to}">{{ item.name }}</router-link>
      </li>
    </ul>
  </nav>

</template>

<script>
import auth from '@/auth'

export default {
  name: 'Navbar',
  data () {
    return {
      user: auth.user,
      role_map: {
        admin: [
          {to: 'Dashboard', name: 'Dashboard', path: '/app/dashboard'},
          {to: 'VehiclesSummary', name: 'Vehicles', path: '/app/vehicle'},
          {to: 'Payables', name: 'Payables', path: '/app/payable'},
          {to: 'CharitiesSummary', name: 'Charities', path: '/app/charities'},
          {to: 'BuyersSummary', name: 'Buyers', path: '/app/buyers'},
          {to: 'TowingCompaniesSummary', name: 'Towing', path: '/app/towing'},
          {to: 'SourceSummary', name: 'Sources', path: '/app/source'},
          {to: 'UsersSummary', name: 'Users', path: '/app/user'},
          {to: 'Reports', name: 'Reports', path: '/app/report'},
          {to: 'Emails', name: 'Emails', path: '/app/email'}
        ],
        call: [
          {to: 'VehiclesSummary', name: 'Vehicles', path: 'app/vehicles'}
        ],
        charity: [
          {to: 'CharityView', name: 'Vehicles', path: 'app/charity-view'},
          {to: 'Donation', name: 'Donation Widget', path: 'app/donation'}
        ],
        charity_prospect: [
          {to: 'PreviewAccount', name: 'Vehicles', path: 'app/preview-vehicles'},
          {to: 'DonationPreview', name: 'Donation Widget', path: 'app/preview-donation'}
        ]
      }
    }
  },
  props: {
    noLogin: {
      default: false
    }
  },
  methods: {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue